import { Link } from 'react-router-dom';
import { siteInfo } from '@/mocks/siteInfo';

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[580px] md:min-h-[680px] flex items-center overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: `url('https://readdy.ai/api/search-image?query=Warm%20abstract%20illustration%20with%20soft%20overlapping%20organic%20shapes%20in%20gentle%20coral%20and%20cream%20tones%2C%20calm%20nurturing%20atmosphere%2C%20modern%20minimalist%20design%2C%20flowing%20curved%20forms%2C%20educational%20theme%2C%20warm%20ambient%20light%2C%20inclusive%20and%20supportive%20visual%20language&width=1800&height=1200&seq=hero-main-2025&orientation=landscape')`,
        }}
      />
      <div className="absolute inset-0 bg-gradient-to-b from-foreground-900/50 via-foreground-900/30 to-foreground-900/60" />

      <div className="relative z-10 w-full px-6 md:px-10 max-w-7xl mx-auto">
        <div className="flex flex-col items-center text-center">
          <span className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-background-50/20 backdrop-blur-sm text-background-50 text-xs font-medium mb-6 tracking-wide">
            <i className="ri-verified-badge-line" />
            教育部推荐 · 全国青少年健康教育指定资源
          </span>

          <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-background-50 leading-tight max-w-3xl mb-5">
            {siteInfo.tagline}
          </h1>

          <p className="text-base md:text-lg text-background-50/80 max-w-2xl mb-8 leading-relaxed">
            {siteInfo.description}
          </p>

          <div className="flex flex-col sm:flex-row items-center gap-3">
            <Link
              to="/category/puberty"
              className="px-8 py-3.5 bg-primary-500 hover:bg-primary-600 text-background-50 font-medium text-sm rounded-lg transition-all duration-300 hover:scale-[1.02] whitespace-nowrap"
            >
              开始学习
              <i className="ri-arrow-right-line ml-2" />
            </Link>
            <Link
              to="/about"
              className="px-8 py-3.5 bg-background-50/15 hover:bg-background-50/25 backdrop-blur-sm text-background-50 font-medium text-sm rounded-lg transition-all duration-300 hover:scale-[1.02] whitespace-nowrap"
            >
              了解更多
            </Link>
          </div>

          <div className="grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-10 mt-14">
            {siteInfo.brandHighlights.map((item) => (
              <div key={item.label} className="text-center">
                <div className="text-2xl md:text-3xl font-heading font-bold text-background-50 mb-1">
                  {item.number}
                </div>
                <div className="text-xs md:text-sm text-background-50/60">
                  {item.label}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}